<template>
  <div id="coupons">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a href="javascript:;" class="navbar-nav-link" @click="isFilterEnabled = !isFilterEnabled"
              >{{ this.$t("event.components.participants.navbar.filterRecord") }}<i class="fas fa-search ml-1" :class="($store.state.coupons.filter.searchTerm != null && $store.state.coupons.filter.searchTerm != '') || ($store.state.coupons.filter.packetID != null && $store.state.coupons.filter.packetID != '') || ($store.state.coupons.filter.type != null && $store.state.coupons.filter.type != '') ? 'animate__animated animate__pulse animate__infinite text-info' : ''"></i>
            </a>
          </li>
          <li class="nav-item">
            <a
              href="javascript:;"
              class="navbar-nav-link"
              @click="
                updateForm = null;
                modalVisible = true;
              "
              >{{ this.$t("event.components.participants.navbar.add") }}<i class="icon-plus3 ml-1"></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="filter-card card card-collapsed">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">{{ this.$t("event.filter.title") }}</h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button
                      size="mini"
                      @click="
                        $store.state.registrationforms.filter.searchTerm = '';
                        $store.state.registrationforms.filter.packetID = null;
                        $store.state.registrationforms.filter.type = null;
                      "
                      round
                      >{{ $t("event.buttons.reset") }}</el-button
                    >
                    <el-button size="mini" type="danger" @click="isFilterEnabled = false" round>{{ $t("event.buttons.close") }}</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-4">
                  <el-input clearable v-model="$store.state.registrationforms.filter.searchTerm" :placeholder="$t('event.textbox.search')"></el-input>
                </div>

                <div class="form-group col-md-4">
                  <el-select v-model="$store.state.registrationforms.filter.packetID" :placeholder="$t('event.textbox.filterPack')" @clear="$store.state.registrationforms.filter.packetID = null" clearable>
                    <el-option v-for="item in $store.state.packets.items" :key="item.id" :label="item.title" :value="item.id"></el-option>
                  </el-select>
                </div>

                <div class="form-group col-md-4">
                  <el-select clearable @clear="$store.state.registrationforms.filter.type = null" v-model="$store.state.registrationforms.filter.type" :placeholder="$t('event.textbox.filterAreaType')">
                    <el-option v-for="item in $enums.inputTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{ this.$t("event.menu.registrationforms.title") }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini" @click="$store.dispatch('getCoupons')"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo :total="$store.state.registrationforms.filter.total" :skip="skip" :take="take" />

          <el-table v-loading="$store.state.registrationforms.loading" ref="multipleTable" :data="getItems" style="width: 100%" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
            <el-table-column property="orderNO" :label="$t('event.table.sequence')" min-width="50"></el-table-column>
            <el-table-column property="title" :label="$t('event.table.title')" min-width="120"></el-table-column>
            <el-table-column property="title" :label="$t('event.table.packages')" min-width="200">
              <template slot-scope="scope">
                <span style="display: block" v-for="item in scope.row.packetIDs" :key="item.id">
                  {{ $store.state.packets.items.find(k => k.id == item).title }}
                </span>
              </template>
            </el-table-column>
            <el-table-column property="usage" :label="$t('event.table.type')" min-width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.type > -1">
                  {{ $enums.inputTypes.find(k => k.value == scope.row.type).title }}
                </span>
                <span v-if="scope.row.type == -1">-</span>
                <span v-if="scope.row.type == -2">-</span>
              </template>
            </el-table-column>
            <el-table-column property="usage" :label="$t('event.table.required')" min-width="70">
              <template slot-scope="scope">
                <span>{{ scope.row.isRequired ? $t("event.variables.yes") : $t("event.variables.no") }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('event.table.onAir')" width="170">
              <template slot-scope="scope">
                <el-switch v-if="scope.row.type > -1" @change="statusChanged($event, scope.$index - 2)" v-model="$store.state.registrationforms.items[scope.$index - 2].isActive" :active-text="$t('event.variables.yes')" :inactive-text="$t('event.variables.no')"></el-switch>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('event.table.processes')" width="110" fixed="right">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.type > -1" class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                  <el-button
                    type="primary"
                    icon="fas fa-pen"
                    circle
                    size="mini"
                    @click="
                      updateForm = JSON.parse(JSON.stringify(scope.row));
                      modalVisible = true;
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip v-if="scope.row.type > -1" class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm @confirm="deleteItem(scope.$index - 2)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                    <el-button slot="reference" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="$t('event.tags.editCustom')" class="xlarge" center modal-append-to-body destroy-on-close>
      <RegistrationFormAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" @itemUpdated="itemUpdated" @itemAdded="itemAdded" :data="updateForm" />
    </el-dialog>
  </div>
</template>

<script>
import RegistrationFormAddUpdate from "../../components/RegistrationFormAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Registrations forms"
  },
  components: { RegistrationFormAddUpdate, ExcelImport, PageCountInfo },
  name: "RegistrationForm",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "coupons",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  methods: {
    itemUpdated(item) {
      var index = this.$store.state.registrationforms.items.findIndex(k => k.id == item.id);
      if (index != -1) {
        this.$store.state.registrationforms.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getRegistrationForms");
    },
    handleSizeChange(take) {
      this.$store.commit("setRegistrationFormTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setRegistrationFormPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deleteRegistrationForm", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleRegistrationForm", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedRegistrationForms", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  mounted() {
    this.$store.dispatch("getRegistrationForms");
  },
  created() {},
  computed: {
    getItems() {
      return [
        {
          orderNO: "#",
          title: "İsim",
          id: -1,
          packetIDs: [],
          type: -1,
          isRequired: true,
          isActive: true
        },
        {
          orderNO: "#",
          title: "Soyisim",
          id: -2,
          packetIDs: [],
          type: -2,
          isRequired: true,
          isActive: true
        },
        ...this.$store.state.registrationforms.items
      ];
    },
    skip() {
      return (this.$store.state.registrationforms.filter.page - 1) * this.$store.state.registrationforms.filter.take;
    },
    take() {
      return this.skip + this.$store.state.registrationforms.items.length;
    }
  },
  watch: {
    "$store.state.registrationforms.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getRegistrationForms");
      }, 500);
    },
    "$store.state.registrationforms.filter.type": function() {
      this.$store.dispatch("getRegistrationForms");
    },
    "$store.state.registrationforms.filter.packetID": function() {
      this.$store.dispatch("getRegistrationForms");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/event/RegistrationForm.vue